// extracted by mini-css-extract-plugin
module.exports = {"levelTable":"LevelTable_levelTable_14CWn"};